if(!customElements.get('sticky-footer')) {
  class stickyForm extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      window.addEventListener('scroll', (event) => {
        this.stickyFooter()
      });

      window.addEventListener('load', (event) => {
        this.stickyFooter()
      });

      // document.addEventListener('DOMContentLoaded', (event) => {
        // console.log('DOMContentLoaded, adding promise-container');

        // let loadBwpScript = document.createElement('div');
        // loadBwpScript.setAttribute('class', 'delivery-promise__promise-container');

        // this.appendChild(loadBwpScript);
      // })
    }

    stickyFooter() {
      if(window.outerWidth < 767) {
        var proheight = $('.Product__Gallery').height()-200;

        if($(window).scrollTop() > proheight) {
          $('.form__foot').css({'transform': 'scale(1)', 'transition': '0.3s ease-in-out'});
          this.classList.add('form__foot_sticky');
        } else {
          this.classList.remove('form__foot_sticky');
          $('.form__foot').css({'transform': 'unset'});
        }
      } else {
        this.classList.remove('form__foot_sticky');
      }
    }
  }

  customElements.define('sticky-footer', stickyForm);
}
